import { cn } from '@/lib/utils';
import type { ArtifactType } from '@/config/objects/artifacts';

interface ArtifactTypeBadgeProps {
  type: ArtifactType;
  className?: string;
  /** Use 'solid' variant for dark backgrounds */
  variant?: 'default' | 'solid';
}

const typeConfig: Record<ArtifactType, { label: string; default: string; solid: string }> = {
  scramble: {
    label: 'Scramble',
    default: 'bg-red-100 text-red-800',
    solid: 'bg-red-500 text-white',
  },
  freeze: {
    label: 'Freeze',
    default: 'bg-sky-100 text-sky-800',
    solid: 'bg-sky-500 text-white',
  },
  blackout: {
    label: 'Blackout',
    default: 'bg-zinc-100 text-zinc-800',
    solid: 'bg-zinc-600 text-white',
  },
  steal: {
    label: 'Steal',
    default: 'bg-orange-100 text-orange-800',
    solid: 'bg-orange-500 text-white',
  },
  misdirect: {
    label: 'Misdirect',
    default: 'bg-amber-100 text-amber-800',
    solid: 'bg-amber-500 text-white',
  },
  shield: {
    label: 'Shield',
    default: 'bg-blue-100 text-blue-800',
    solid: 'bg-blue-500 text-white',
  },
  double_down: {
    label: 'Double Down',
    default: 'bg-purple-100 text-purple-800',
    solid: 'bg-purple-500 text-white',
  },
};

export function ArtifactTypeBadge({ type, className, variant = 'default' }: ArtifactTypeBadgeProps) {
  const config = typeConfig[type];
  if (!config) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        config[variant],
        className,
      )}
    >
      {config.label}
    </span>
  );
}
